// Verification questions are ALWAYS about the past or present, so the client can
// judge an astrologer's accuracy (準唔準) — never about the future.
// Two flavours: 概括 (broad, let the astrologer free-read a life area) and 具體
// (specific, chart-readable facts that test 睇盤 ability).

export const CUSTOM_OPTION = '__custom__';

export const QUESTION_CATEGORIES = [
  {
    category: '概括（命理師自由發揮）',
    questions: [
      '我的家庭',
      '我的事業',
      '我的財富',
      '我的感情',
      '我的健康',
      '我的性格',
    ],
  },
  {
    category: '性格特質（現在）',
    questions: [
      '我的性格比較內向還是外向？',
      '我是否容易緊張或情緒化？',
      '我做決定時偏理性還是感性？',
      '我是否比較固執、有主見？',
      '我是否容易感到沉悶、喜歡新鮮感？',
    ],
  },
  {
    category: '家庭背景（過去／現在）',
    questions: [
      '我與父母的關係如何？',
      '我在家中的排行（長／中／幼）？',
      '我父母的婚姻關係如何？',
      '我與兄弟姊妹的緣分／關係如何？',
      '我童年的家境（富裕／普通／清貧）？',
    ],
  },
  {
    category: '感情婚姻（過去／現在）',
    questions: [
      '我目前是單身、有伴侶還是已婚？',
      '我的感情經歷是多還是少？',
      '我在感情中偏主動還是被動？',
      '我是否經歷過重大的分手或感情創傷？',
    ],
  },
  {
    category: '事業學業（過去／現在）',
    questions: [
      '我目前從事哪一類性質的工作？',
      '我讀書時期的成績如何？',
      '我是否轉過行業或換過多份工作？',
      '我在工作中偏領導型還是執行型？',
      '我是受僱，還是自己創業／做生意？',
    ],
  },
  {
    category: '財富（現在）',
    questions: [
      '我目前的財務狀況是穩定還是緊張？',
      '我是節儉型還是花費型？',
      '我是否已經置業（有沒有物業）？',
      '我的收入主要來自正財（薪資）還是偏財？',
    ],
  },
  {
    category: '健康（過去／現在）',
    questions: [
      '我身體哪方面比較弱？',
      '我是否做過手術或患過大病？',
      '我的睡眠或腸胃狀況如何？',
    ],
  },
  {
    category: '人生經歷（過去）',
    questions: [
      '我過去幾年是否有重大轉變（搬家／轉職／移民）？',
      '我童年的身體狀況如何？',
      '我人生中是否有過明顯的低潮期？大約幾歲？',
      '我是否長期離開出生地、在外地生活？',
    ],
  },
];
